import { createSlice } from '@reduxjs/toolkit'
// Interfaces
import type { PayloadAction } from '@reduxjs/toolkit'
import type { IMovieStore } from 'interfaces/IMovieStore'
import type { RootState } from 'stores/Store'

// Initial State
const initialState: IMovieStore = {
  menuActive: '/',
  isGlobalLoading: false,
}

export const MovieSlice = createSlice({
  name: 'movie',

  initialState,

  reducers: {
    setMenuActive: (state, action: PayloadAction<string>) => {
      state.menuActive = action.payload
    },
    setGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.isGlobalLoading = action.payload
    },
  },
})

// Export actions
export const { setMenuActive, setGlobalLoading } = MovieSlice.actions

// Export state
export const getMenuActive = (state: RootState) => state.counter.menuActive
export const getGlobalLoading = (state: RootState) => state.counter.isGlobalLoading

export default MovieSlice.reducer
